import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';
import { jurisLob } from '../../../../functions/claim/jurisLob';
import { leaveLob } from '../../../../functions/claim/leaveLinkLob';
import { getClaimKey } from '../../../../functions/get-claim-key';
import { ExaminerDiary } from '../../../../models/api/view/claim/documentation/examiner-diary/examiner-diary';
import { BaseComponent } from '../../../base/base.component';
import { RadioButtonComponent } from '../../../core/controls/radio-button.component';
import { SelectComponent } from '../../../core/controls/select.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { ActionRowComponent } from '../../../core/panels/action-row.component';
import { DiaryTableAccommodationComponent } from '../../../todo/client-diaries/diary-table-accommodation.component';
import { DiaryTableJurisComponent } from '../../../todo/client-diaries/diary-table-juris.component';
import { DiaryTableLeaveComponent } from '../../../todo/client-diaries/diary-table-leave.component';

@Component({
  selector: 'app-examiner-diary',
  imports: [
    RouterModule,
    ReactiveFormsModule,
    SelectComponent,
    ActionRowComponent,
    PageHeaderComponent,
    DiaryTableJurisComponent,
    DiaryTableLeaveComponent,
    DiaryTableAccommodationComponent,
    RadioButtonComponent,
  ],
  template: `
    <app-page-header label="Examiner diary">
      <ng-template #right>
        @if (juris) {
          <div class="tw-flex tw-items-center ">
            <div class="tw-grow tw-min-w-64">
              <app-select
                [options]="noteLevel"
                optionLabel="description"
                optionValue="value"
                class="tw-basis-1/5"
                [virtualScroll]="false"
                [control]="level"
                label="Level"
                [multiple]="false"
                [filter]="false"
                [showClear]="false"
                [showHelpText]="false"
              />
            </div>
          </div>
        }
      </ng-template>
    </app-page-header>

    <app-action-row>
      <div right1>
        <app-radio-button
          [control]="fg.controls.diaryStatus"
          label=""
          screenReaderLabel="Diary status"
          optionLabel="description"
          optionValue="value"
          [options]="diaryStatusOptions"
          [vertical]="false"
        ></app-radio-button>
      </div>
    </app-action-row>

    @if (juris) {
      <app-diary-table-juris
        [searchLevel]="level.value"
        [filteredStatus]="fg.get('diaryStatus').value"
        [diaryData]="dataSource"
      />
    } @else if (accommodation) {
      <app-diary-table-accommodation
        [filteredStatus]="fg.get('diaryStatus').value"
      />
    } @else {
      <app-diary-table-leave [filteredStatus]="fg.get('diaryStatus').value" />
    }
  `,
  styles: ``,
})
export class ExaminerDiaryComponent extends BaseComponent implements OnInit {
  juris = false;
  accommodation = false;
  leave = false;

  dataSource: ExaminerDiary[] = [];

  level = new FormControl<string>('claim');

  fg = new FormGroup({
    diaryStatus: new FormControl<string>('Open'),
  });
  diaryStatusOptions = [
    { description: 'Open', value: 'Open' },
    { description: 'Completed', value: 'Completed' },
  ];
  noteLevel = [
    { description: 'Claim', value: 'claim' },
    { description: 'Claimant', value: 'clmnt' },
    { description: 'Event', value: 'event' },
  ];

  @HandleLoadingState({ useViewLoading: true })
  async ngOnInit() {
    const claim = this.view.currentClaim();
    this.juris = jurisLob(claim?.lineOfBusiness);
    this.accommodation = claim?.lineOfBusiness === 'AD';
    this.leave = leaveLob(claim?.lineOfBusiness);
    this.dispose.subs = this.level.valueChanges.subscribe((level) =>
      this.search(level),
    );
    if (this.juris) {
      await this.search(this.level.value);
    }
  }

  async search(level: string) {
    const key = getClaimKey();
    const item = await this.api.examinerDiary.get(key, level);
    this.dataSource = item.examinerDiaries;
  }
}
